export enum ClaimDetailsType {
  Consumer,
  Tenant,
  System,
}
